import { render, staticRenderFns } from "./menuAccount.vue?vue&type=template&id=011477d8"
import script from "./menuAccount.vue?vue&type=script&lang=ts"
export * from "./menuAccount.vue?vue&type=script&lang=ts"
import style0 from "./menuAccount.vue?vue&type=style&index=0&id=011477d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports